import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import React from "react";
import SvgIconPikabu from "../util/SvgIconPikabu";
import SvgIconReddit from "../util/SvgIconReddit";
import SvgIconNUUM from "../util/SvgIconNUUM";
import {useLocale} from "../locale/Locale";

function AppTrash() {

    const {localeText} = useLocale()

    const xs = 12
    const sm = 6
    const md = 3

    // const xs = 12
    // const sm = 4
    // const md = 4

    return (
        <>
            <Typography variant="h2" align="center">{localeText('trashTitle')}</Typography>
            <Typography align="center" mb={2}>{localeText('trashDescription')}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://pikabu.ru/@NanakiLucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.success.main}}>
                                        <SvgIconPikabu/>
                                    </Avatar>
                                }
                                title={localeText('pikabu')}
                                subheader="@NanakiLucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.reddit.com/user/isaev_space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconReddit/>
                                    </Avatar>
                                }
                                title="Reddit"
                                subheader="u/isaev_space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://nuum.ru/channel/isaev-space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconNUUM/>
                                    </Avatar>
                                }
                                title="NUUM"
                                subheader="@isaev-space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://plvideo.ru/@isaevspace"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{
                                        color: useTheme().palette.text.primary,
                                        bgcolor: useTheme().palette.background.default
                                    }}>П</Avatar>
                                }
                                title={localeText('platform')}
                                subheader="@isaevspace"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppTrash
